import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ADPResourceService } from 'digital-core';
import { NgxMaskPipe } from 'ngx-mask';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ContractGuard } from 'src/app/core/guards/contract.guard';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { IFamilyMember } from 'src/app/model/contract/IContract';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { EditAvatarModalComponent } from '../edit-avatar-modal/edit-avatar-modal.component';

@Component({
  selector: 'pgh-account-profile',
  templateUrl: './account-profile.component.html',
  styleUrls: ['./account-profile.component.scss'],
})
export class AccountProfileComponent implements OnInit, OnDestroy {
  @Output() changeAvatarAction = new EventEmitter();
  user: UserClaims;
  contract: ISelectedContract;
  isActive: boolean = false;
  member: IFamilyMember;
  telephoneNum: any;
  selMember$: Observable<IFamilyMember>;
  isDialogLoaded: boolean = false;
  initialLoad: boolean = false;

  private $destroy = new Subject<boolean>();

  constructor(
    private loggedInUserSettings: LoggedInUserSettings,
    private matDialog: MatDialog,
    private contractGuard: ContractGuard,
    private maskPipe: NgxMaskPipe,
    public resourceService: ADPResourceService
  ) {}

  ngOnDestroy() {
    this.$destroy.next(true);
  }

  ngOnInit() {
    combineLatest([this.loggedInUserSettings.$selectedContract, this.loggedInUserSettings.$userClaims])
      .pipe(
        filter(([a, b]) => a !== null && b !== null),
        takeUntil(this.$destroy)
      )
      .subscribe(([contract, user]) => {
        this.member = !contract.isEprismContract ? 
          contract.members.find(x => x.emailAddress?.toLowerCase() === user.email.toLowerCase()) :
          contract.members.find(x => x.phoneNumber === contract.oktaPrimaryPhone);
        this.user = user;
        this.contract = contract;
        this.isActive = this.contractGuard.activateGuard(contract);
        this.selMember$ = of(this.member);
      });

    this.initialLoad = true;
  }

  get canChangeAvatar() {
    if (!this.contract.isEprismContract) {
      return (
        this.contract.primaryUserEmail?.toLowerCase() === this.user.email?.toLowerCase() ||
        this.member.emailAddress?.toLowerCase() === this.user.email?.toLowerCase()
      );
    } else {
      return true;
    }    
  }

  maskPhone(entry: any) {
    return this.maskPipe.transform(entry.toString(), this.resourceService.getPortalSetting('Global_Mask_Phone').Value);
  }

  openEditAvatarModal() {
    this.initialLoad = false;
    this.isDialogLoaded = false;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.ariaLabel = this.resourceService.getPortalLabel('Global_EditAvatar_ARIA_Label').Value;

    dialogConfig.data = {
      member: this.member,
      user: this.user,
      contract: this.contract,
      profileTab: true,
    };

    const dialogRef = this.matDialog.open(EditAvatarModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      if (res.data) {
        this.isDialogLoaded = true;
        this.selMember$ = null;

        setTimeout(() => {
          this.selMember$ = of(this.member);
        }, 100);
      }
    });
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
